export default __webpack_public_path__ + "open-roll-face-fix.jpg";